<!-- ToDo:  Error info row - update error icon -->
<div class="panel" [class.panel-danger]="isError()" [class.panel-warning]="isWarning()">
    <div class="panel-heading">
        <h3 class="panel-title">Error Info</h3>
    </div>
    <div class="panel-body" [class.pb-0]="showDetails()">
        <div class="row">
            <div class="col-sm-10 error-info-grid message-column-divider">
                <ep-svg-icon class="icon-column top-row" icon="ban" extraClasses="text-danger"></ep-svg-icon>

                <b class="header-column top-row">Exception message</b>
                <div class="message-column preserve-lines top-row">{{exceptionInstanceResult()?.ExceptionMessage}}</div>

                <b class="header-column">Exception cause</b>
                <div class="message-column preserve-lines">{{exceptionInstanceResult()?.ExceptionType?.ExceptionCause}}
                </div>

                <b class="header-column">Exception solution</b>
                <div class="message-column preserve-lines">
                    {{exceptionInstanceResult()?.ExceptionType?.ExceptionSolution}}</div>
            </div>
            <div class="col-sm-2">
                <button (click)="toggleShowDetails()" class="btn btn-block" [class.btn-danger]="isError()"
                    [class.btn-warning]="isWarning()">
                    {{showDetails() ? 'Show less' : 'Show more'}}
                </button>
                @if (hasAiAccess()){
                <button type="button" (click)="requestAiInterpret(!!exceptionInstanceInterpretation())"
                    class="btn btn-block mt-2 ai-request-button">
                    <img class="ai-button-icon" ngSrc="/css/images/label-ai-black-transparent.svg" width="20" height="20" alt="" aria-hidden="true">
                    <span>{{ exceptionInstanceInterpretation() ? 'Ask A.I. again' : 'Ask A.I.' }}</span>
                </button>
                }
            </div>
        </div>
    </div>
    <div class="panel-body pt-0 panel-animate" [hidden]="!showDetails()">
        <div class="row">
            <div class="col-sm-12 error-info-grid message-column-divider">
                <b class="header-column">Error time</b>
                <div class="message-column">{{$safeNavigationMigration(exceptionInstanceResult()?.CreatedDate) |
                    date:'yyyy-MM-dd HH:mm:ss.SSS'}}</div>

                <b class="header-column">Stakeholder</b>
                <div class="message-column">{{exceptionInstanceResult()?.Stakeholder?.Name}}</div>

                <b class="header-column">Error code</b>
                <div class="message-column">{{exceptionInstanceResult()?.ExceptionType?.ErrorCode}}</div> 

                <b class="header-column">Category</b>
                <div class="message-column">
                    {{exceptionInstanceResult()?.ExceptionType?.ExceptionCategory?.ExceptionCategoryName}}</div>

                <b class="header-column">Category description</b>
                <div class="message-column">{{exceptionInstanceResult()?.ExceptionType?.ExceptionCategory?.Description}}
                </div>

                <b class="header-column">Area</b>
                <div class="message-column">{{exceptionInstanceResult()?.ExceptionType?.Area}}</div>

                <b class="header-column">Component</b>
                <div class="message-column">{{exceptionInstanceResult()?.ExceptionType?.Component}}</div>

                <b class="header-column">Technical description</b>
                <div class="message-column preserve-lines">
                    {{exceptionInstanceResult()?.ExceptionType?.TechnicalDescription}}</div> 

                <b class="header-column">Stack trace</b>
                <div class="message-column">
                    <pre class="form-control-static">{{exceptionInstanceResult()?.Exception}}</pre>
                </div>
            </div>
        </div>
    </div>

    @if (exceptionInstanceInterpretation()){
    <div class="panel-body pt-0 panel-animate">
        <div class="ai-insight-header">
            <img class="ai-generated-label" ngSrc="/css/images/label-ai-generated-white.svg" width="112" height="36" alt="AI Generated">  
            <div class="ai-vote">
                <span class="ai-vote-label">Helpful?</span>
                <div class="btn-group btn-group-xs" role="group" aria-label="AI vote">
                    <button type="button" class="btn" [class.btn-success]="aiVoteState() === 'up'"
                        [class.btn-default]="aiVoteState() !== 'up'" (click)="submitAiInterpretationVote('up')"
                        title="Thumbs up">
                        👍
                    </button>

                    <button type="button" class="btn" [class.btn-danger]="aiVoteState() === 'down'"
                        [class.btn-default]="aiVoteState() !== 'down'" (click)="submitAiInterpretationVote('down')"
                        title="Thumbs down">
                        👎
                    </button>
                </div>

                @switch (aiVoteState()) {
                @case ('pending') {
                <span class="ai-vote-status">Sending…</span>
                }
                @case ('up') {
                <span class="ai-vote-status">Thanks!</span>
                }
                @case ('down') {
                <span class="ai-vote-status">Thanks!</span>
                }
                }
            </div>
        </div>

        @if (voteError()) {
        <div class="alert alert-warning ai-vote-error">
            {{ voteError() }}
        </div>
        }

        <div class="row">
            <div class="col-sm-12 error-info-grid message-column-divider">
                <b class="header-column">Summary</b>
                <div class="message-column" [innerHtml]="exceptionInstanceInterpretation().Summary"></div>

                <b class="header-column">Likely Cause</b>
                <div class="message-column" [innerHtml]="exceptionInstanceInterpretation().LikelyCause"></div>

                <b class="header-column">Suggested Fix</b>
                <div class="message-column" [innerHtml]="exceptionInstanceInterpretation().SuggestedFix"></div>

                <b class="header-column">Questions to Confirm</b>
                <div class="message-column" [innerHtml]="exceptionInstanceInterpretation().QuestionsToConfirm"></div>
            </div>
        </div>
    </div>
    }
</div>